import React, { PureComponent } from "react";
import styled from "styled-components";
import { AbstractTimelineContext } from "../abstract-timeline";
import tinycolor from "tinycolor2";
// tslint:disable: variable-name
const DotContainer = styled.div `
  display: flex;
  width: 100%;
  justify-content: space-between;
  width: 96px;
  height: 2px;
  position: relative;
  overflow: hidden;
`;
/**
 * 横向流星
 *
 * 播放进度条
 *
 * @author 张卓诚
 * @export
 * @class Progress
 * @extends {PureComponent<ProgressProps>}
 * @implements {ICSS}
 */
export class Progress extends PureComponent {
    render() {
        // tslint:disable: jsx-no-multiline-js
        return (React.createElement(AbstractTimelineContext.Consumer, null, data => {
            const elapses = data.elapses[this.props.yearIndex].children
                .map((item, index) => index < data.dayIndex ? item.total : item.elapse);
            const preElapse = elapses
                .slice(0, this.props.dayIndex)
                .reduce((item1, item2) => item1 + item2, 0);
            const yearElapse = elapses
                .reduce((item1, item2) => item1 + item2, 0);
            const dayElapse = yearElapse - preElapse;
            const total = data.elapses[this.props.yearIndex].children[this.props.dayIndex].total;
            const progress = dayElapse / total;
            return (React.createElement(DotContainer, { className: this.props.className, style: this.props.style },
                React.createElement("div", { style: {
                        height: "100%",
                        width: 74,
                        background: `linear-gradient(to right,
                    ${tinycolor(this.props.colorPalette.mainColor[1]).setAlpha(0).toRgbString()} ,
                    ${tinycolor(this.props.colorPalette.mainColor[1]).setAlpha(0.35).toRgbString()} 65%,
                    ${tinycolor(this.props.colorPalette.mainColor[1]).setAlpha(1).toRgbString()} 88%,
                    ${tinycolor(this.props.colorPalette.mainColor[1]).setAlpha(1).toRgbString()} 97.3%,
                    #ffffff 97.3%,
                    #ffffff
                  )`,
                        position: "absolute",
                        right: -(progress - 1) * 96,
                    } })));
        }));
    }
}
//# sourceMappingURL=progress.js.map